module.exports = __webpack_public_path__ + "img/crunchbase.82b52272.svg";